<div class="toast-stack" aria-live="polite" aria-atomic="false">
  @for (toast of toasts(); track toast.id) {
    <div class="toast-stack__item" [class]="'toast-stack__item--' + toast.variant" role="status">
      <i class="bx {{ iconFor(toast.variant, toast.icon) }} toast-stack__icon" aria-hidden="true"></i>
      <span class="toast-stack__message">{{ toast.message }}</span>
      <button type="button" class="toast-stack__close" aria-label="Dismiss notification" (click)="dismiss(toast.id)">
        <i class="bx bx-x" aria-hidden="true"></i>
      </button>
    </div>
  }
</div>
